import React, { useState } from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import FormHelperText from '@material-ui/core/FormHelperText'
import * as Cognito from '../../lib/cognito-api'

const ResendConfirmationCode = ({ username }) => {
  const [isCodeResent, setIsCodeResent] = useState(false)
  const [resendError, setResendError] = useState(null)

  const onResendConfirmationCode = async () => {
    try {
      setResendError(null)
      await Cognito.resendConfirmationCode({ username })
      setIsCodeResent(true)
    } catch (error) {
      // should we do anything? or fail silently?
      switch (error.code) {
        case 'InvalidParameterException':
          setResendError(error.message)
          break
        case 'LimitExceededException':
          setResendError('Attempt limit exceeded, please try again after some time')
          break
        case 'UserNotFoundException':
          setResendError('Unable to resend verification code: User not found')
          break
        default:
          setResendError('An unexpected error occurred. Please try again.')
          break
      }
    } finally {
      setTimeout(() => {
        setIsCodeResent(false)
      }, 5000)
    }
  }

  return (
    <>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Typography variant="body2">Didn't receive a code?</Typography>
        <Button color="primary" disabled={isCodeResent} onClick={onResendConfirmationCode}>
          {!isCodeResent ? 'Resend it' : 'Sent!'}
        </Button>
      </Box>
      {resendError && (
        <Box display="flex" justifyContent="center">
          <FormHelperText error={true}>{resendError}</FormHelperText>
        </Box>
      )}
    </>
  )
}

export default ResendConfirmationCode
